import React from "react";
import axios from "axios";
import { BsPencil, BsTrash } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import Config from "../../../Config";
import {
  OnestNormalDefault,
  OnestSemiBoldDefault,
} from "../../styled/TextComponents";
import {
  color_grey_light,
  color_red_default,
  color_red_default_t20,
  color_white,
} from "../../../constants/colors";
import { splitTitleAndBody } from "./updateContent";
import UpdatesAdminForm from "./UpdatesAdminForm";
import moment from "moment";
import { useI18n } from "../../../i18n/I18nProvider";

const updatesAdminText = "#222222";
const updatesAdminMuted = "#707070";

const UpdatesAdminListItem = ({ change, onFetchChanges }) => {
  const { locale, t } = useI18n();
  const [editing, setEditing] = React.useState(false);
  const [isWaiting, setIsWaiting] = React.useState(false);

  const { title } = splitTitleAndBody(change.text);
  const { title: titleEn } = splitTitleAndBody(change.text_en);
  const displayTitle = title || titleEn || t("Новость #{{id}}", { id: change.id });

  const handleDelete = () => {
    if (!window.confirm(t("Удалить эту новость?"))) return;
    setIsWaiting(true);
    axios
      .delete(`${Config.BACKEND_ADDR}/changes/${change.id}`)
      .then((response) => {
        if (response.status === 200) onFetchChanges();
      })
      .finally(() => setIsWaiting(false));
  };

  const handleSave = (payload) => {
    setIsWaiting(true);
    axios
      .patch(`${Config.BACKEND_ADDR}/changes/`, {
        change_id: change.id,
        type: payload.type,
        address: payload.address,
        text: payload.text,
        text_en: payload.text_en || "",
      })
      .then((response) => {
        if (response.status === 200) {
          onFetchChanges();
          setEditing(false);
        }
      })
      .finally(() => setIsWaiting(false));
  };

  if (editing) {
    return (
      <UpdatesAdminForm
        mode="edit"
        initialChange={change}
        onCancel={() => setEditing(false)}
        onSubmit={handleSave}
        isWaiting={isWaiting}
      />
    );
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "14px 16px",
        borderRadius: 14,
        border: `1px solid ${color_grey_light}`,
        background: color_white,
      }}
    >
      {isWaiting && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 14,
            background: color_red_default_t20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <InfinitySpin width={120} color={color_red_default} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <OnestSemiBoldDefault
          style={{ fontSize: 16, fontWeight: 600, color: updatesAdminText }}
        >
          {displayTitle}
        </OnestSemiBoldDefault>
        <OnestNormalDefault style={{ fontSize: 13, color: updatesAdminMuted }}>
          {moment(change.time_create).locale(locale === "en" ? "en-gb" : "ru").format("LL")}
        </OnestNormalDefault>
      </div>
      <button
        type="button"
        onClick={() => setEditing(true)}
        style={iconButtonStyle}
        aria-label={t("Редактировать")}
      >
        <BsPencil />
      </button>
      <button
        type="button"
        onClick={handleDelete}
        style={iconButtonStyle}
        aria-label={t("Удалить")}
      >
        <BsTrash />
      </button>
    </div>
  );
};

const iconButtonStyle = {
  width: 40,
  height: 40,
  borderRadius: 10,
  border: `1px solid ${color_grey_light}`,
  background: color_white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: updatesAdminMuted,
  fontSize: 18,
};

export default UpdatesAdminListItem;
